import api from "../index"

const aboutUsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAboutUs: build.query({
      query: ({ key }) => ({
        url: `/about-us/get/${key}`,
        method: "GET",
      }),
    }),

    updateAboutUs: build.mutation({
      query: (body) => ({
        url: `/about-us/update`,
        method: "POST",
        body,
      }),
    }),

    updateFounderMessage: build.mutation({
      query: (body) => ({
        url: `/about-us/update/founder-message`,
        method: "POST",
        body,
      }),
    }),

    updateAboutIcdMessage: build.mutation({
      query: (body) => ({
        url: `/about-us/update/about-icd`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useUpdateAboutUsMutation,
  useLazyGetAboutUsQuery,
  useUpdateFounderMessageMutation,
  useUpdateAboutIcdMessageMutation,
} = aboutUsApi
